<div class="text-center p-4 header rounded-t-2xl">
    <h1><b> CDFT Form Information </b></h1>
</div>
<div class="grid grid-cols-2 gap-2 px-4 py-3 w-full">
    <div class="w-full">
        <b>Prepared By:</b>
        <p>
            <i>{{ state.preparedBy ?? "(not set)" }}</i>
        </p>
    </div>
    <div class="w-full">
        <b>Approved By:</b>
        <p>
            <i>{{ state.approvedBy ?? "(not set)" }}</i>
        </p>
    </div>
</div>
<hr class="m-0" />
<div class="grid grid-rows-1 gap-2 px-4 py-3 w-full">
    <div>
        <b>Status:</b>

        <span [ngClass]="{
                'ml-2 text-white badge': true,
                'badge-neutral': state.status == cdftStatus.DRAFT,
                'badge-success': state.status == cdftStatus.APPROVED,
                'badge-error': state.status == cdftStatus.REJECTED,
                'badge-primary': state.status == cdftStatus.REVIEWED,
                'badge-warning': state.status == cdftStatus.READY
            }">
            {{ state.status ?? "-" }}
        </span>
    </div>
    <div *ngIf="isViewOnly">
        <b>Overall CDFT Result:</b>
        <span class="ml-2 badge text-white" [ngClass]="{
            'badge-success': state.result == 'Passed',
            'badge-error': state.result == 'Failed',
        }">
            {{ state.result ?? "-" }}
        </span>
    </div>
    <form *ngIf="!isViewOnly" [formGroup]="formGroup">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label><b>Overall CDFT Result:</b></mat-label>
            <input type="text" matInput formControlName="result" [matAutocomplete]="result" />
            <mat-autocomplete autoActiveFirstOption #result="matAutocomplete">
                <mat-option value="Passed">Passed</mat-option>
                <mat-option value="Failed">Failed</mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </form>

    <div *ngIf="state?.failureFactor?.length > 0" class="w-full">
        <b>Failure Factor:</b>

        <ul style="list-style-type: disc;" class="ml-4 pl-1">
            <li>Production Status - {{ formGroup.get('prodStatus').value ?? "-" }}</li>
        </ul>

        <ul style="list-style-type: disc;" class="ml-4 pl-1" *ngFor="let failureFactor of state.failureFactor">
            <li *ngIf="failureFactor.result != 'UTT'">{{ failureFactor.name ?? "-" }}</li>

            <ng-container *ngIf="!failureFactor?.name.includes('Annulus')">
                <li *ngIf="failureFactor.result == 'UTT'">{{ failureFactor.name + " (UTT)" ?? "-" }}</li>
            </ng-container>
        </ul>
    </div>

    <div *ngIf="state?.degradedValves?.length > 0" class="w-full">
        <b>Degraded Valve:</b>

        <ul style="list-style-type: disc;" class="ml-4 pl-1" *ngFor="let degradedValves of state.degradedValves">
            <li>{{ degradedValves.name ?? "-" }}</li>
        </ul>
    </div>

    <div class="w-full">
        <b> CDFT Overall Remark:</b>
        <p>{{ state.overallRemarks ?? "-" }}</p>
    </div>

    <div class="w-full">
        <b>Approval Remark:</b>
        <p>{{ state.remarks ?? "-" }}</p>
    </div>
</div>
<hr class="m-0" />
<div class="grid grid-rows-1 gap-2 px-4 py-3 w-full">
    <div>
        Notes: IF ANY X-MAS TREE VALVE AFTER RESULT IS FAILED, OVERALL CDFT
        RESULT CONSIDER FAILED!
    </div>
</div>